import { render, staticRenderFns } from "./CargoExpenseEdit.vue?vue&type=template&id=623dc440"
import script from "./CargoExpenseEdit.vue?vue&type=script&lang=js"
export * from "./CargoExpenseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports